/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 28/01/22
 */

import { Flex } from '@chakra-ui/react';
import { SimpleAlert } from '@/components/SimpleAlert/SimpleAlert';
import React from 'react';

export const WorkplanNotLoadedAlert = () => (
    <Flex justifyContent="center" mt={6}>
        <SimpleAlert variant="top-accent" title="Error">
            <>
                Could not load Workplan.
                <br />
                Refresh the page to try again, or return to Dashboard.
            </>
        </SimpleAlert>
    </Flex>
);
